module.exports = __webpack_public_path__ + "img/vertical-logo-white.ea90946a.svg";